import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

//import { Menu } from './menu.model';
//import { verticalMenuItems, horizontalMenuItems } from './menu';
import { DataService } from 'src/services/data.service';




@Injectable()
export class MenuService {

    constructor(private location: Location, private dataService: DataService,
        private router: Router) { }

    // public getVerticalMenuItems():Array<Menu> {
    //   return verticalMenuItems;
    // }

    // public getHorizontalMenuItems():Array<Menu> {
    //   return horizontalMenuItems;
    // }

    getHorizontalMenuItems(refresh: Boolean, langId: number) {
        return this.dataService.getRecord(('/api/menulist/' + langId));
    }

    getVerticalMenuItems(refresh: Boolean, langId: number) {
        return this.dataService.getRecord(('/api/verticalmenu/' + langId));
    }

    getSiteMapMenuItems(refresh: Boolean, langId: number) {
        return this.dataService.getRecord(('/api/sitemap/' + langId));
    }


    //public expandActiveSubMenu(menu:Array<Menu>){
    //  let url = this.location.path();
    //  let routerLink = decodeURIComponent(url);
    //  let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
    //  if(activeMenuItem[0]){
    //    let menuItem = activeMenuItem[0];
    //    while (menuItem.parentId != 0){  
    //      let parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
    //      menuItem = parentMenuItem;
    //      this.toggleMenuItem(menuItem.id);
    //    }
    //  }
    //}

    public toggleMenuItem(menuId) {
        let menuItem = document.getElementById('menu-item-' + menuId);
        let subMenu = document.getElementById('sub-menu-' + menuId);
        if (subMenu) {
            if (subMenu.classList.contains('show')) {
                subMenu.classList.remove('show');
                menuItem.classList.remove('expanded');
            }
            else {
                subMenu.classList.add('show');
                menuItem.classList.add('expanded');
            }
        }
    }

    //public closeOtherSubMenus(menu:Array<Menu>, menuId){
    //  let currentMenuItem = menu.filter(item => item.id == menuId)[0];
    //  menu.forEach(item => {
    //    if((item.id != menuId && item.parentId == currentMenuItem.parentId) || (currentMenuItem.parentId == 0 && item.id != menuId) ){
    //      let subMenu = document.getElementById('sub-menu-'+item.id);
    //      let menuItem = document.getElementById('menu-item-'+item.id);
    //      if(subMenu){
    //        if(subMenu.classList.contains('show')){
    //          subMenu.classList.remove('show');
    //          menuItem.classList.remove('expanded');
    //        }              
    //      } 
    //    }
    //  });
    //} 

    //public closeAllSubMenus(){        
    //  verticalMenuItems.forEach(item => {
    //    let subMenu = document.getElementById('sub-menu-'+item.id);
    //    let menuItem = document.getElementById('menu-item-'+item.id);
    //    if(subMenu){
    //      if(subMenu.classList.contains('show')){
    //        subMenu.classList.remove('show');
    //        menuItem.classList.remove('expanded');
    //      }              
    //    } 
    //  });           
    //}


}